<template>
  <div class="company__card">
    <div class="card__content">
      <div class="card__header">
        <div class="card__header-left">
          <img class="card__icon" src="@/assets/icons/ico_lock-accent.svg" alt="">
          <div class="card__text">
            <h2 class="card__title">{{ $t(`${namespace}.title`) }}</h2>
            <p class="card__subtitle">
              {{ $t(`${namespace}.subTitle`) }}
            </p>
          </div>
        </div>
        <div class="card__header-right">
          <div @click.stop="handleShowDialog" class="card__header-right-item">
            {{ $t(`${namespace}.addToken`) }}
            <img src="@/assets/icons/addToken.svg" alt="" class="card__header-right-icon">
          </div>
          <div @click.stop="handleShowList" class="card__header-right-item">
            <img v-if="!showList" src="@/assets/icons/expand.svg" alt="" class="card__header-right-icon">
            <img v-else src="@/assets/icons/expanded.svg" alt="" class="card__header-right-icon">
          </div>
        </div>
      </div>
      <TokenList :tokenListData="tokenListData" :showList="showList" @getTokenListData="getTokenListData"></TokenList>
    </div>
    <AddTokenDialog
      :visible="showAddDialog"
      :companyId="companyId"
      @close="handleCloseDialog"
      @getTokenListData="getTokenListData"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import AddTokenDialog from './AddTokenDialog'
import TokenList from './TokenList'
import companyService from '@/services/company'
export default {
  name: 'AllowApiToken',
  props: {
    data: {
      type: Object,
      default: () => { }
    }
  },
  components: {
    AddTokenDialog,
    TokenList
  },
  data () {
    return {
      namespace: 'Components.AllowApiToken',
      showAddDialog: false,
      showList: false,
      tokenListData: null // null表示异常，tokenListData.list === []表示没有数据
    }
  },
  computed: {
    companyId () {
      const { id } = this.$route.params
      return Number(id) || null
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),
    handleShowDialog () {
      this.showAddDialog = true
    },
    handleCloseDialog () {
      this.showAddDialog = false
    },
    handleShowList () {
      this.showList = !this.showList
      if (this.showList) {
        this.getTokenListData()
      }
    },
    async getTokenListData () {
      try {
        const { data: res } = await companyService.getTokenList({ companyId: this.companyId })
        this.tokenListData = {
          list: res.data || [],
          total: res.data?.length || 0
        }
      } catch (e) {
        this.tokenListData = null
        if (this.showList) {
          this.showAlert({ type: 'error', message: e.errmsg || this.$t(`Components.AllowApiToken.error`) })
        }
      }
    }
  },
  watch: {}
}
</script>

<style lang="scss" scoped>
.company__card {
  margin-bottom: 24px;
  padding: 0 16px;

  .card__content {
    background-color: #fff;
    border: 1px solid $gray-2;
    max-width: 840px;
    transition: box-shadow 0.26s;

    &:hover {
      @media (min-width: 992px) {
        box-shadow: 0 1px 6px rgba(#000, 0.25);
      }
    }

    .card__header {
      color: $gray-7;
      font-family: 'Montserrat', sans-serif;
      font-weight: 700;
      padding: 18px 24px;
      position: relative;
      border-bottom: 1px solid $gray-2;
      display: flex;
      justify-content: space-between;

      .card__header-left {
        .card__icon {
          left: 16px;
          margin-right: 10px;
          padding: 0 2px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 24px;
        }

        .card__text {
          padding-left: 31px;
          padding-right: 45px;

          .card__title {
            font-size: 18px;
            font-weight: 800;
          }

          .card__subtitle {
            color: $gray-6;
            font-family: "Work Sans", sans-serif;
            margin-bottom: 0;
            font-size: 12px;
            font-weight: normal;
            text-transform: none;
          }
        }
      }

      .card__header-right {
        display: flex;
        align-items: center;
        .card__header-right-item {
          display: flex;
          align-items: center;
        }
        .card__header-right-icon {
          cursor:pointer;
          margin-right: 20px;
          width: 18px;
          height: 18px;
        }
      }
    }
  }
}
</style>
